/* EVCARS phase 1: saved vehicle, visitor country, compatibility badge, related products. */
(() => {
  const VKEY = 'ev_vehicle';
  const CKEY = 'ev_country';
  const PARAM = 'filter.p.m.custom.compatible_vehicles';
  const html = document.documentElement;
  const qs = new URLSearchParams(location.search);
  const T = window.EV_T || {};
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const store = {
    get(k, s = localStorage) { try { return s.getItem(k); } catch (e) { return null; } },
    set(k, v, s = localStorage) { try { v == null ? s.removeItem(k) : s.setItem(k, v); } catch (e) {} },
  };
  const gid = (id) => (String(id).startsWith('gid://') ? String(id) : 'gid://shopify/Metaobject/' + id);

  const EV = (window.EV = {
    vehicles() {
      const el = document.getElementById('ev-vehicles');
      if (!el) return [];
      let list;
      try { list = JSON.parse(el.textContent); } catch (e) { return []; }
      // Makes with the most models first (Tesla), keeping the admin order inside a make
      const n = {};
      list.forEach((v) => { n[v.make] = (n[v.make] || 0) + 1; });
      return list.map((v, i) => [v, i]).sort((a, b) => n[b[0].make] - n[a[0].make] || a[0].make.localeCompare(b[0].make) || a[1] - b[1]).map((x) => x[0]);
    },
    universal() { return EV.vehicles().find((v) => v.universal); },
    get() {
      let v = null;
      try { v = JSON.parse(store.get(VKEY)); } catch (e) {}
      if (!v) return null;
      // Re-read the label in the current language; drop vehicles that were deleted.
      const list = EV.vehicles();
      if (list.length) {
        const fresh = list.find((x) => x.handle === v.handle);
        if (!fresh) { store.set(VKEY, null); return null; }
        return fresh;
      }
      return v;
    },
    set(v) {
      store.set(VKEY, v ? JSON.stringify({ id: v.id, handle: v.handle, label: v.label }) : null);
      document.dispatchEvent(new CustomEvent('ev:vehicle', { detail: v }));
    },
    filterUrl(base, v) {
      const u = new URL(base, location.origin);
      u.searchParams.delete(PARAM);
      u.searchParams.delete('ev_all');
      u.searchParams.delete('page');
      u.searchParams.append(PARAM, gid(v.id));
      const un = EV.universal();
      if (un) u.searchParams.append(PARAM, gid(un.id));
      return u.pathname + u.search;
    },
    /** Where choosing a car leads: its own collection as the store arranged it, else every product that fits it. */
    carUrl(v, base) {
      if (v && v.col) return v.col + '?ev_all=1';
      return EV.filterUrl(base || root + 'collections/all', v);
    },
    country() { return html.dataset.evCountry || 'unknown'; },
    PARAM,
  });

  /* ---------- The saved car travels with the order ----------
     Cart attributes "Car" (shown to staff on the order) and "ev_vehicle" (the handle, for segments and
     repeat-purchase flows). Only written when the cart has items, so browsing never creates a cart. */
  EV.syncCar = () => {
    const v = EV.get();
    const handle = v && !v.universal ? v.handle : '';
    const label = handle ? [v.make, v.model, v.years].filter(Boolean).join(' ') || v.label : '';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        if (!c.item_count || (c.attributes.ev_vehicle || '') === handle) return;
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { Car: label, ev_vehicle: handle } }) });
      })
      .catch(() => {});
  };
  document.addEventListener('ev:vehicle', () => EV.syncCar());

  /* WhatsApp consent (cart checkbox) → cart attribute, which Shopify copies into the checkout and the order. */
  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-ev-wa-optin]');
    if (!box) return;
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'WhatsApp updates': box.checked ? 'yes' : '' } }) }).catch(() => {});
  });
  EV.syncCar();

  /* ---------- Visitor country (Tabby/Tamara, installation, shipping row) ---------- */
  function setCountry(c) {
    html.dataset.evCountry = c ? c.toUpperCase() : 'unknown';
    document.dispatchEvent(new CustomEvent('ev:country', { detail: EV.country() }));
  }
  const forced = qs.get('ev_country'); // testing: ?ev_country=SA
  if (forced) store.set(CKEY, forced.toUpperCase(), sessionStorage);
  const cached = store.get(CKEY, sessionStorage);
  if (cached) setCountry(cached);
  else
    fetch(root + 'browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((d) => {
        const c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (c) store.set(CKEY, c, sessionStorage);
        setCountry(c);
      })
      .catch(() => setCountry(null));

  /* ---------- Auto-apply the saved vehicle on collection and search pages ---------- */
  const isList = /\/collections\/[^/]+\/?$|\/search\/?$/.test(location.pathname);
  const saved = EV.get();
  if (isList && saved && !qs.has(PARAM) && !qs.has('ev_all')) {
    location.replace(EV.filterUrl(location.href, saved));
    return;
  }

  /* ---------- Picker ---------- */
  class EvPicker extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-ev-grid]');
      this.back = this.querySelector('[data-ev-back]');
      this.crumb = this.querySelector('[data-ev-crumb]');
      this.steps = [...this.querySelectorAll('[data-ev-step]')];
      this.back.addEventListener('click', () => this.go(this.step - 1));
      this.sel = {};
      this.go(1);
    }
    list() { return EV.vehicles().filter((v) => !v.universal); }
    uniq(a) { return [...new Set(a)]; }
    go(step) {
      this.step = Math.max(1, step);
      if (this.step === 1) this.sel = {};
      if (this.step === 2) delete this.sel.model;
      const all = this.list();
      let items = [];
      if (this.step === 1) {
        items = this.uniq(all.map((v) => v.make)).map((m) => ({ text: m, pick: () => { this.sel.make = m; this.next(); } }));
      } else if (this.step === 2) {
        items = this.uniq(all.filter((v) => v.make === this.sel.make).map((v) => v.model)).map((m) => ({
          text: m, pick: () => { this.sel.model = m; this.next(); },
        }));
      } else {
        items = all
          .filter((v) => v.make === this.sel.make && v.model === this.sel.model)
          .map((v) => ({ text: v.years || T.allYears, pick: () => this.choose(v) }));
      }
      this.steps.forEach((s, i) => s.toggleAttribute('data-active', i + 1 === this.step));
      this.back.hidden = this.step === 1;
      this.crumb.textContent = [this.sel.make, this.sel.model].filter(Boolean).join(' · ');
      this.grid.replaceChildren(
        ...items.map((it) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ev-chip';
          b.textContent = it.text;
          b.addEventListener('click', it.pick);
          return b;
        })
      );
    }
    next() {
      // Skip a step that has only one choice (e.g. a model with a single year range).
      this.go(this.step + 1);
      if (this.grid.children.length === 1 && this.step === 3) this.grid.children[0].click();
    }
    choose(v) {
      EV.set(v);
      const dlg = this.closest('dialog');
      if (isList && !/\/collections\/all\/?$/.test(location.pathname)) return location.assign(EV.filterUrl(location.href, v));
      if (isList || this.dataset.redirect) return location.assign(EV.carUrl(v, this.dataset.redirect));
      if (dlg) dlg.close();
      this.go(1);
    }
  }
  customElements.get('ev-picker') || customElements.define('ev-picker', EvPicker);

  /* ---------- Bar, dialog, badge ---------- */
  function render() {
    const v = EV.get();
    document.querySelectorAll('[data-ev-bar]').forEach((bar) => {
      bar.querySelector('[data-ev-has]').hidden = !v;
      bar.querySelector('[data-ev-none]').hidden = !!v;
      bar.querySelector('[data-ev-label]').textContent = v ? v.label : '';
      const all = bar.querySelector('[data-ev-all]');
      if (all) {
        const filtered = isList && v && qs.has(PARAM);
        all.hidden = !filtered;
        if (filtered) {
          const u = new URL(location.href);
          u.searchParams.delete(PARAM);
          u.searchParams.set('ev_all', '1');
          all.href = u.pathname + u.search;
        }
      }
    });
    document.querySelectorAll('[data-ev-fit]').forEach((fit) => {
      const handles = (fit.dataset.handles || '').split(',').filter(Boolean);
      const universal = fit.dataset.universal === 'true';
      const st = universal ? 'all' : !v ? 'unknown' : handles.includes(v.handle) ? 'yes' : 'no';
      fit.dataset.state = st;
      fit.querySelectorAll('[data-ev-v]').forEach((el) => (el.textContent = v ? v.label : ''));
    });
  }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-ev-open]');
    if (open) {
      const dlg = document.querySelector('[data-ev-dialog]');
      if (dlg) { e.preventDefault(); dlg.showModal(); }
    }
    const clear = e.target.closest('[data-ev-clear]');
    if (clear) {
      EV.set(null);
      if (isList) {
        const u = new URL(location.href);
        u.searchParams.delete(PARAM);
        location.assign(u.pathname + u.search);
      }
    }
    const dlg = e.target.closest('[data-ev-dialog]');
    if (dlg && (e.target === dlg || e.target.closest('[data-ev-close]'))) dlg.close();
  });
  function renderShipping() {
    const c = EV.country();
    document.querySelectorAll('.ev-ship__list').forEach((ul) => {
      const rows = [...ul.querySelectorAll('[data-ev-countries]')];
      const mine = rows.find((r) => r.dataset.evCountries.includes(',' + c + ','));
      rows.forEach((r) => (r.hidden = !!mine && r !== mine));
      ul.toggleAttribute('data-single', !!mine);
    });
  }
  document.addEventListener('ev:country', renderShipping);
  document.addEventListener('ev:vehicle', () => { render(); loadRelated(); });

  /* ---------- Related products for the same vehicle (product page and cart) ---------- */
  function loadRelated() {
    document.querySelectorAll('[data-ev-related]').forEach((box) => {
      const v = EV.get();
      const own = (box.dataset.handles || '').split(',').filter(Boolean);
      const list = EV.vehicles();
      const target = v && (!own.length || own.includes(v.handle)) ? v : list.find((x) => own.includes(x.handle) && !x.universal);
      if (!target) { box.hidden = true; return; }
      const exclude = (box.dataset.exclude || '').split(',').filter(Boolean);
      const url = EV.filterUrl(root + 'collections/all', target) + '&sort_by=best-selling&section_id=' + box.dataset.section;
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const items = [...doc.querySelectorAll('[data-ev-item]')].filter((li) => !exclude.includes(li.dataset.evItem));
          const max = Number(box.dataset.limit || 4);
          const slot = box.querySelector('[data-ev-related-list]');
          slot.replaceChildren(...items.slice(0, max));
          box.querySelectorAll('[data-ev-v]').forEach((el) => (el.textContent = target.label));
          box.hidden = !items.length;
        })
        .catch(() => (box.hidden = true));
    });
  }

  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-ev-add]');
    if (!f) return;
    e.preventDefault();
    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(f) }).then(() => location.reload());
  });

  render();
  renderShipping();
  loadRelated();
})();
